export default "__VITE_ASSET__D8U3$qLL__"